import { SchoolListQuery, SchoolType } from "@interfaces/school"
import KyMethod from "./KyMethod"

export default class SchoolRepositories extends KyMethod {
  protected async getRawSchoolList(
    type: SchoolType,
    { page = 1, limit = 12, search }: Partial<SchoolListQuery>
  ) {
    return this._getData(`/schools`, {
      type: type ? type.toLocaleLowerCase() : "school",
      page,
      limit,
      ...(search && { search }),
    })
  }
}
